export const LICENSE_TYPES = {
  Access: 'Access',
  AddOn: 'AddOn',
  Trial: 'Trial',
} as const;

export type LicenseType = typeof LICENSE_TYPES[keyof typeof LICENSE_TYPES];
